<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Avatar from 'dashboard/components-next/avatar/Avatar.vue';

const props = defineProps({
  accountId: { type: [Number, String], required: true },
  guide: { type: Object, required: true },
  selected: { type: Boolean, default: false },
});

const { t } = useI18n();
const preview = computed(
  () =>
    props.guide.messages?.findLast(message => message.text)?.text ||
    props.guide.greeting
);
</script>

<template>
  <router-link
    :to="{ name: 'activation_guide', params: { accountId } }"
    :aria-label="`${t('ACTIVATION_GUIDE.NAME')} — ${t('ACTIVATION_GUIDE.IDENTITY')}`"
    :aria-current="selected ? 'page' : undefined"
    class="conversation relative flex w-full gap-2 px-3 py-3 border-b border-n-slate-3 text-n-slate-12 hover:bg-n-alpha-1 dark:hover:bg-n-alpha-3 focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-n-brand"
    :class="{ 'active bg-n-background !border-n-surface-1': selected }"
  >
    <Avatar
      :name="t('ACTIVATION_GUIDE.NAME')"
      icon-name="i-lucide-bot"
      :size="32"
      class="mt-1 shrink-0"
    />
    <div class="flex-1 min-w-0">
      <h4 class="m-0 pt-0.5 text-sm font-medium truncate text-n-slate-12">
        {{ t('ACTIVATION_GUIDE.NAME') }}
      </h4>
      <p class="m-0 text-xs leading-5 text-n-slate-11 truncate">
        {{ t('ACTIVATION_GUIDE.IDENTITY') }}
      </p>
      <p class="m-0 text-sm leading-6 text-n-slate-11 truncate">
        {{ preview }}
      </p>
    </div>
  </router-link>
</template>
